import type { EndlessBoard, Phase } from '../../shared/protocol';

export interface InputContext {
  roundId: string | null;
  phase: Phase;
  endlessBoard: Pick<EndlessBoard, 'number'> | null;
}

/**
 * Whether a server message invalidates the player's in-progress selection. Only a new
 * board (a new round, or the next Endless board) or leaving play does; a reconnect snapshot
 * for the same board keeps the tiles the player already has under their finger, as does a
 * same-round countdown snapshot that arrives after this browser opened play at `startAt`.
 */
export function shouldResetInput(
  previous: InputContext,
  message: {
    t: string;
    currentRoundId?: string | null;
    phase?: Phase;
    endlessBoard?: Pick<EndlessBoard, 'number'>;
  },
): boolean {
  if (message.t !== 'state') return false;
  if ((message.currentRoundId ?? null) !== previous.roundId) return true;
  // An Endless round replaces its board without changing the round.
  if (message.endlessBoard && message.endlessBoard.number !== previous.endlessBoard?.number) return true;
  return previous.phase === 'playing' && message.phase !== 'playing' && message.phase !== 'countdown';
}
